import React, { useEffect, useState } from "react";
import Mainservice from "../Mainservice/Mainservice";
import "./Mainservices.css";

const Mainervices = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    fetch("/service.json")
      .then((res) => res.json())
      .then((data) => setServices(data));
  }, []);
  return (
    <>
      <div id="Services">
        <h1 className="m-4 p-5 main">Our Services</h1>
      </div>

      <div className="service-container">
        {services.map((service) => (
          <Mainservice key={service.id} service={service}></Mainservice>
        ))}
      </div>
    </>
  );
};

export default Mainervices;
